import React from 'react';
import { formatShortId } from '../../utils/formatShortId';

const baseStyle = {
  display: 'inline-block',
  width: '8ch',
  maxWidth: '8ch',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'clip',
  lineHeight: 1.2,
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
};

const ShortId = ({ id, copyOnClick = false }) => {
  const fullId = id === null || id === undefined ? '' : String(id);
  const shortId = formatShortId(id);

  const handleClick = async () => {
    if (!copyOnClick || !fullId || !navigator?.clipboard?.writeText) {
      return;
    }

    try {
      await navigator.clipboard.writeText(fullId);
    } catch (_) {
      // Silent fallback: tooltip/title keeps full ID available.
    }
  };

  return (
    <span
      title={fullId || '-'}
      style={{ ...baseStyle, cursor: copyOnClick && fullId ? 'copy' : 'default' }}
      onClick={handleClick}
    >
      {shortId}
    </span>
  );
};

export default ShortId;
